import React from 'react';
import { useSelector } from 'react-redux';
import Text from '../Shared/Text';
import CheckOrCross from '../Shared/CheckOrCross';
import { checkCustomPackage } from '../../../../../services/package';

const ProfessionalVoiceClonesFeature = ({ pkg }) => {
  const optionsSelected = useSelector(
    (state) => state.packages.optionsSelected,
  );

  const isCustomPackage = checkCustomPackage({
    type: pkg.type,
    level: pkg.level,
  });
  if (isCustomPackage) {
    const minVoiceClonings = pkg?.customResource?.voiceClonings?.min || 0;
    const totalVoiceClonings =
      minVoiceClonings + optionsSelected?.voiceClonings;
    return <Text key={pkg.code} text={totalVoiceClonings} />;
  }
  if (pkg?.maxCloningVoices) {
    return <Text key={pkg.code} text={pkg?.maxCloningVoices} />;
  }
  return <CheckOrCross key={pkg.code} isCheck={false} />;
};

const professionalVoiceClonesFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <ProfessionalVoiceClonesFeature key={pkg.code} pkg={pkg} />
  ));

export default professionalVoiceClonesFeatures;
